export default __webpack_public_path__ + "static/media/2022_April_Feuer.533bd3d6.webp";